import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const EditPurchase = () => {
  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [user_id, setUserId] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [invoice, setInvoice] = useState("");
  const [date, setDate] = useState("");
  const [purchaseBy, setPurchaseBy] = useState("");
  const [categories, setCategories] = useState([]);
  const [categoryItems, setCategoryItems] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // 🔹 Get user_id from localStorage
  useEffect(() => {
    const userid = localStorage.getItem("user_id");
    if (userid) setUserId(userid);
  }, []);

  // 🔹 Fetch vendors and categories
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [vendorRes, categoryRes] = await Promise.all([
          axios.get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/"),
          axios.get("https://ims-backend.indevconsultancy.in/admin-panel/category/"),
        ]);
        setVendors(vendorRes.data);
        setCategories(categoryRes.data);
      } catch (err) {
        console.error("Error fetching vendors/categories:", err);
      }
    };
    fetchData();
  }, []);

  // 🔹 Fetch existing purchase
  useEffect(() => {
    const fetchPurchase = async () => {
      try {
        const storedId = localStorage.getItem("purchase_id_edit");
        if (storedId) {
          console.log("Editing purchase ID:", storedId);
          const res = await axios.get(
            `https://api-ims.indevconsultancy.in/purchase-edit.php?user_id=${user_id}&parchase_id=${storedId}`
          );
          const data = res.data.data;

          setVendor(data.vendor_id);
          setInvoice(data.invoice_no);
          setDate(data.date);
          setPurchaseBy(data.parchase_by);

          const mappedItems = data.items.map((item) => ({
            id: Date.now() + Math.random(),
            parchase_id: item.parchase_id,
            category: item.category_id,
            name: item.items_id,
            stock_name: item.stock_name,
            items_name: item.items_name,
            quantity: item.quantity,
            unit: item.unit,
            total: item.total_amount,
          }));
          setItems(mappedItems);

          // fetch items for each category
          mappedItems.forEach((item) => {
            fetchItemsByCategory(item.category, item.id);
          });
        }
      } catch (err) {
        console.error("Error fetching purchase:", err);
      }
    };

    if (user_id) fetchPurchase();
  }, [user_id]);

  const fetchItemsByCategory = async (categoryId, rowId) => {
    if (!categoryId) return;
    try {
      const res = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/itemlist/?categoryid=${categoryId}&kitchenid=19`
      );
      setCategoryItems((prev) => ({
        ...prev,
        [rowId]: res.data,
      }));
    } catch (err) {
      console.error(`Error fetching items for row ${rowId}:`, err);
    }
  };

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        id: Date.now(),
        category: "",
        name: "",
        stock_name: "",
        items_name: "",
        quantity: "",
        unit: "",
        total: "",
      },
    ]);
  };

  const handleRemoveItem = (id) => {
    if (items.length > 1) setItems(items.filter((item) => item.id !== id));
  };

  const handleItemChange = (id, field, value) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
            ...item,
            [field]: value,
            total:
              field === "quantity" || field === "unit"
                ? (field === "quantity"
                  ? parseFloat(value || 0) * parseFloat(item.unit || 0)
                  : parseFloat(item.quantity || 0) * parseFloat(value || 0)) || ""
                : item.total,
          }
          : item
      )
    );
  };

  const handleReset = () => {
    setVendor("");
    setInvoice("");
    setDate("");
    setPurchaseBy("");
    setItems([
      {
        id: Date.now(),
        category: "",
        name: "",
        stock_name: "",
        items_name: "",
        quantity: "",
        unit: "",
        total: "",
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!vendor) newErrors.vendor = true;
    if (!invoice) newErrors.invoice = true;
    if (!date) newErrors.date = true;
    if (!purchaseBy) newErrors.purchaseBy = true;

    items.forEach((item, index) => {
      if (!item.category) newErrors[`category_${index}`] = true;
      if (!item.name) newErrors[`name_${index}`] = true;
      if (!item.quantity) newErrors[`quantity_${index}`] = true;
      if (!item.unit) newErrors[`unit_${index}`] = true;
      if (!item.total) newErrors[`total_${index}`] = true;
    });

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);

    const purchaseId = items[0]?.parchase_id || Math.floor(10000000 + Math.random() * 90000000);

    const payload = {
      user_id,
      parchase_id: purchaseId,
      invoice_no: invoice,
      date,
      parchase_by: purchaseBy,
      created_at: new Date().toISOString(),
      status: 1,
      del_action: "N",
      vendor,
      items: items.map((item) => ({
        parchase_id: purchaseId,
        category_id: item.category,
        items_id: item.name,
        stock_name: item.stock_name,
        items_name: item.items_name,
        quantity: item.quantity,
        unit: item.unit,
        total_amount: item.total,
      })),
    };

    try {
      const res = await axios.post(
        `https://api-ims.indevconsultancy.in/purchase-update.php`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      alert("Purchase updated successfully!");
      navigate("/purchasePO");
    } catch (err) {
      console.error("Error updating purchase:", err);
      alert("Failed to update purchase.");
    } finally {
      setLoading(false);
    }
  };

  const grandTotal = items.reduce((sum, item) => sum + (Number(item.total) || 0), 0);

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-6 text-start">
          <h5>Edit Purchase</h5>
        </div>
        <div className="col-md-6 text-end">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-end mb-0">
              <li className="breadcrumb-item active" aria-current="page">
                Edit Purchase
              </li>
              <li className="breadcrumb-item">
                <Link to="/purchasePO">List Purchase Items</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">Edit Purchase</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3 row">
              <div className="col-6">
                <label className="form-label">Vendor Name</label>
                <select
                  className="form-select"
                  value={vendor}
                  onChange={(e) => setVendor(e.target.value)}
                >
                  <option value="">Select Vendor</option>
                  {vendors.map((v) => (
                    <option key={v.vendor_id} value={v.vendor_id}>
                      {v.vendor_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <label className="form-label">Invoice No.</label>
                <input
                  type="text"
                  className="form-control"
                  value={invoice}
                  onChange={(e) => setInvoice(e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-6">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label">Purchase By</label>
                <input
                  type="text"
                  className="form-control"
                  value={purchaseBy}
                  onChange={(e) => setPurchaseBy(e.target.value)}
                />
              </div>
            </div>

            {items.map((item) => (
              <div key={item.id} className="row g-2 mb-3 align-items-end">
                <div className="col-md-2">
                  <label className="form-label">Category</label>
                  <select
                    className="form-control"
                    value={item.category || ""}
                    onChange={(e) => {
                      const categoryId = e.target.value;
                      handleItemChange(item.id, "category", categoryId);
                      fetchItemsByCategory(categoryId, item.id);
                    }}
                  >
                    <option value="">Select Category</option>
                    {categories.map((c) => (
                      <option key={c.category_id} value={c.category_id}>
                        {c.category_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Item</label>
                  <select
                    className="form-control"
                    value={item.name || ""}
                    onChange={(e) => {
                      const selectedId = Number(e.target.value);
                      const selectedItem = categoryItems[item.id]?.find(
                        (it) => it.stock_id === selectedId
                      );
                      handleItemChange(item.id, "name", selectedId);
                      handleItemChange(item.id, "stock_name", selectedItem?.stock_name || "");
                      handleItemChange(item.id, "items_name", selectedItem?.items_name || "");
                      handleItemChange(item.id, "unit", selectedItem?.price || "");
                      handleItemChange(item.id, "total", (item.quantity || 0) * (selectedItem?.price || 0));
                    }}
                  >
                    <option value="">Select Item</option>
                    {categoryItems[item.id]?.map((it) => (
                      <option key={it.stock_id} value={it.stock_id}>
                        {it.items_name || it.stock_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(item.id, "quantity", parseFloat(e.target.value))}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">Unit Price</label>
                  <input
                    type="number"
                    className="form-control"
                    value={item.unit}
                    onChange={(e) => handleItemChange(item.id, "unit", parseFloat(e.target.value))}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">Total</label>
                  <input
                    type="text"
                    className="form-control"
                    value={item.total}
                    readOnly
                  />
                </div>

                <div className="col-md-1">
                  <button type="button" className="btn btn-success w-100" onClick={handleAddItem}>
                    +
                  </button>
                </div>
                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-danger w-100"
                    onClick={() => handleRemoveItem(item.id)}
                    disabled={items.length === 1}
                  >
                    -
                  </button>
                </div>
              </div>
            ))}

            <div className="text-end">
              <h4>Total Price: {grandTotal}</h4>
            </div>

            <div className="text-end">
              <button className="btn btn-secondary me-2" type="button" onClick={handleReset}>
                Clear
              </button>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditPurchase;
